module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      exclusive: _vm.$route.name === 'membership' || _vm.isExclusive
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.aboutUsMobileRoute) ? _c('AboutUs') : (_vm.bulkOrderMobilePage) ? _c('BulkOrderMobilePage') : (_vm.contactUsMobile) ? _c('ContactUsMobile', {
    attrs: {
      "hideMyAccountLink": true
    }
  }) : (_vm.privacyPolicyMobile) ? _c('PrivacyPolicyMobile', {
    attrs: {
      "contactUs": '/contact-us-mobile',
      "renderContactUsMobile": _vm.renderContactUsMobile
    }
  }) : (_vm.termsNconditionMobile) ? _c('TermsNconditionsMobile') : (_vm.theUlimateTeeRoute) ? _c('UltimateTee') : (_vm.covidReliefFundMobile) ? _c('CovidReliefFundMobile') : (_vm.pauseForPawsMobile) ? _c('PauseForPawsMobile') : (_vm.maintenance) ? _c('Maintenance') : (_vm.authMobile) ? _c('AuthMobile') : (_vm.careersMobile) ? _c('CareersMobile') : _c('div', [_c('div', [(_vm.isExclusive) ? _c('exclusive-nav-bar', {
    attrs: {
      "isExclusive": _vm.isExclusive
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDesktop) ? _c('app-nav-layout') : (!_vm.isDesktop) ? _c('App-nav-mobile') : _vm._e()], 1), _vm._v(" "), _c('GenderDOBModal', {
    on: {
      "closeModal": _vm.closeModal
    },
    model: {
      value: (_vm.genderDOBModal),
      callback: function($$v) {
        _vm.genderDOBModal = $$v
      },
      expression: "genderDOBModal"
    }
  }), _vm._v(" "), _c('LogoutModal', {
    attrs: {
      "isVisible": _vm.showLogoutModal,
      "title": "Confirm Logout"
    },
    on: {
      "update:isVisible": _vm.updateModalVisibility,
      "confirm": _vm.confirmLogout
    }
  }, [_c('div', {
    staticClass: "logoutContent"
  }, [_c('img', {
    staticClass: "emoji-img",
    attrs: {
      "src": "https://prod-img.thesouledstore.com/static/goodbye-image.jpg",
      "alt": "Sad Emoji"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "logout-message"
  }, [_vm._v("Are you sure you want to logout?")])])]), _vm._v(" "), _c('div', {
    class: {
      'bg-lgrey': _vm.isSupimaLanding || _vm.isWinterWearLanding,
      'activewear-grey': _vm.isActiveWearLanding
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    class: ['tss-body-wrapper', {
      'minHeight': _vm.isHomeRoute
    }, {
      'pdpMinHeight': _vm.isPdpRoute
    }]
  }, [_c('router-view', {
    staticClass: "viewContainer"
  })], 1)])], 1), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('overlay'), _vm._v(" "), (_vm.isWelcomeOfferPopup && !_vm.bannerPlaceHolderForGoForAppOnlySale) ? _c('WelcomeOfferModal', {
    attrs: {
      "toggleWelcomeOfferPopup": _vm.toggleWelcomeOfferPopup,
      "msgArr": _vm.bannerPlaceHolderForWelcomeOffer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isBdayDiscountPopup && !_vm.bannerPlaceHolderForGoForAppOnlySale) ? _c('BirthdayDiscountModal', {
    attrs: {
      "toggleBdayDiscountPopup": _vm.toggleBdayDiscountPopup,
      "msgArr": _vm.bannerPlaceHolderForBirthdayDiscount
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isTssBdayPopup && _vm.bannerPlaceHolderForTSSBirthday && _vm.bannerPlaceHolderForTSSBirthday.status) ? _c('TSSBirthdayModal', {
    attrs: {
      "toggleTssBdayPopup": _vm.toggleTssBdayPopup,
      "msgArr": _vm.bannerPlaceHolderForTSSBirthday
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1003
// module chunks = 113